"use client";

import { motion } from "framer-motion";
import { cn } from "@/utils/cn";

type AnimatedListProps = {
  items: string[];
  className?: string;
  itemClassName?: string;
  itemHeight?: number;
  visibleItems?: number;
  duration?: number;
};

export function AnimatedList({
  items,
  className,
  itemClassName,
  itemHeight = 30,
  visibleItems = 3,
  duration = 12,
}: AnimatedListProps) {
  if (!items.length) return null;

  const duplicated = [...items, ...items];
  const cycleDistance = items.length * itemHeight;

  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-xl border border-white/20 bg-black/25",
        className,
      )}
      style={{ height: itemHeight * visibleItems }}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 z-10 h-8 bg-gradient-to-b from-black/70 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-8 bg-gradient-to-t from-black/70 to-transparent" />

      <motion.div
        animate={{ y: [0, -cycleDistance] }}
        transition={{
          duration,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {duplicated.map((item, index) => (
          <div
            key={`${item}-${index}`}
            className={cn(
              "text-white/88 flex items-center px-3 text-[11px] uppercase tracking-[0.16em]",
              itemClassName,
            )}
            style={{ height: itemHeight }}
          >
            {item}
          </div>
        ))}
      </motion.div>
    </div>
  );
}
